<template>
  <div>
    <KTCodePreview v-bind:title="'Đổi sản phẩm'">
      <template v-slot:preview>
        <b-form ref="form" class="row">
          <!-- Input session -->
          <b-container class="bv-example-row">
            <b-row>
              <b-col>
                <div class="form-group">
                  <span>
                    <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                    đúng format, hoặc có thể tải ở
                    <a :href="urlExcel">đây</a>
                  </span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <span> <b>Bước 2:</b> Tiến hành Import </span>
                <div style="padding-top: 15px">
                  <b-form-file
                    placeholder="Hãy chọn một tập tin"
                    @change="selectFile"
                    v-model="file"
                    ref="file-input"
                    class="mb-2"
                  ></b-form-file>
                </div>
                <b-progress :value="progress" :max="100" show-progress>
                  <b-progress-bar
                    :value="progress"
                    :label="`${progress.toFixed(2)}%`"
                  ></b-progress-bar>
                </b-progress>
              </b-col>
            </b-row>
          </b-container>
          <!-- End input session -->

          <b-container class="mt-10">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="selectedStatus"
                :aria-describedby="ariaDescribedby"
                name="radios-btn-default"
                buttons
                @change="onChangeStatus()"
              >
                <b-form-radio value="all"
                  >Tất cả
                  <span class="text-primary"
                    >({{ countAll }})</span
                  ></b-form-radio
                >
                <b-form-radio value="valid"
                  >Hợp lệ
                  <span class="text-success"
                    >({{ countValid }})</span
                  ></b-form-radio
                >
                <b-form-radio value="error"
                  >Lỗi
                  <span class="text-danger"
                    >({{ countError }})</span
                  ></b-form-radio
                ></b-form-radio-group
              >
            </b-form-group>
            <b-table
              class="myTable"
              bordered
              hover
              :fields="fields"
              :items="importItems"
              :per-page="50"
              :current-page="currentPage"
              id="my-table-product"
            >
              <template v-slot:cell(productType)="row">
                <span v-if="row.item.chassisNumber && row.item.engineNumber">
                  SK: {{ row.item.chassisNumber }} <br />
                  SM:
                  {{ row.item.engineNumber }}
                </span>
                <span v-if="row.item.serialNumber"
                  >SERI:{{ row.item.serialNumber }}</span
                >
              </template>
              <template v-slot:cell(isValid)="row">
                <b-button
                  variant="secondary"
                  disabled
                  v-if="row.item.isValid === null"
                >
                  <b-spinner small></b-spinner>
                </b-button>
                <span
                  v-else
                  v-text="getStatusName(row.item)"
                  class="label font-weight-bold label-lg label-inline"
                  v-bind:class="{
                    'label-light-success': row.item.isValid === true,
                    'label-light-danger': row.item.isValid === false,
                  }"
                  style="width: max-content"
                ></span>
              </template>
              <template v-slot:cell(originalPrice)="row">
                <span>{{ formatPrice(row.item.originalPrice) }}</span>
              </template>
            </b-table>
            <b-pagination
              v-show="importItems.length > 10"
              v-model="currentPage"
              :total-rows="importItems.length"
              :per-page="50"
              aria-controls="my-table-product"
              align="right"
            ></b-pagination>
          </b-container>
        </b-form>
      </template>
      <template v-slot:foot>
        <div class="bv-example-row container">
          <b-row>
            <b-button
              style="fontweight: 600; width: 60px"
              variant="primary"
              size="sm"
              @click="importProduct"
              >Lưu</b-button
            >
            <router-link to="/products" tag="button">
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                >Hủy</b-button
              >
            </router-link>
          </b-row>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>
<style scoped>
.table th,
.table td {
  text-align: center;
}

.myTable /deep/ .table {
  width: max-content !important;
  color: #464e5f;
  background-color: transparent;
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import xlsx from 'xlsx';
import ApiService from '@/core/services/api.service';
import { URL_IMPORT_CHANGE_PRODUCT } from '../../../utils/constants';
import { cloneDeep } from '../../../utils/common';
import { makeToastSuccess, makeToastFaile, formatPrice } from '@/utils/common';

export default {
  data() {
    return {
      formatPrice,
      fields: [
        {
          key: 'storeName',
          label: 'Kho',
          thStyle: { width: '15%' },
        },
        {
          key: 'productType',
          label: 'Số Khung / Số Máy / Số Seri',
          thStyle: { width: '15%' },
        },
        {
          key: 'productOld',
          label: 'Tên sản phẩm hiện tại',
          thStyle: { width: '20%' },
        },
        {
          key: 'productNew',
          label: 'Tên sản phẩm mới',
          thStyle: { width: '20%' },
        },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          thStyle: {
            width: '10%',
            color: 'rgb(24, 28, 50)',
          },
          tdClass: 'text-right',
        },
        {
          key: 'isValid',
          label: 'Trạng thái',
          thStyle: { width: '5%' },
        },
        {
          key: 'message',
          label: 'Thông báo',
          thStyle: { width: '25%' },
        },
      ],
      importItems: [],
      tmpItems: [],
      file: null,
      excellist: [],
      progress: 0,
      uploading: false,
      urlExcel: URL_IMPORT_CHANGE_PRODUCT,
      currentPage: 1,
      selectedStatus: 'all',
    };
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Đổi sản phẩm' }]);
  },
  computed: {
    countAll() {
      return this.tmpItems.length;
    },
    countValid() {
      return this.tmpItems.filter((item) => item.isValid === true).length;
    },
    countError() {
      return this.tmpItems.filter((item) => item.isValid === false).length;
    },
  },
  methods: {
    convertPrice: function (number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    importProduct: async function () {
      this.uploading = true;
      if (this.countError > 0) {
        makeToastFaile('Vui lòng xử lý dữ liệu lỗi hoặc xóa dữ liệu lỗi!');
        return;
      }
      if (!this.importItems) {
        return;
      }

      this.onCallApiChangeProduct(this.importItems);
    },
    onCallApiChangeProduct(listData) {
      ApiService.post('products/change-list', listData)
        .then((response) => {
          const { message } = response.data;
          makeToastSuccess(message);
          this.$router.go(0);
          this.uploading = false;
        })
        .catch(({ response }) => {
          const { status, message } = response.data;
          if (status === 0) {
            makeToastFaile(message);
            this.uploading = false;
          }
        });
    },
    onValidateData(listData) {
      ApiService.post('products/validate-change', listData)
        .then((response) => {
          const { status, message } = response.data;
          if (status === 1) {
            this.importItems = response.data.data;
            this.clearFiles();
            this.tmpItems = cloneDeep(this.importItems);
            this.onChangeStatus();
            makeToastSuccess(message);
          } else {
            makeToastFaile(message);
          }
          this.uploading = false;
        })
        .catch((response) => {
          makeToastFaile(
            response.data.message || 'Có lỗi xảy ra vui lòng thử lại sau!!!',
          );
          this.uploading = false;
        });
    },
    selectFile(event) {
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          });
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.excellist = excellist;
          if (this.excellist.length > 500) {
            return alert(
              'Để đám bảo hệ thống hoạt động ổn định, chỉ hỗ trợ kích hoạt tối đa 500 IMEI trên một lần thao tác!',
            );
          }
          this.importItems = this.excellist.map((element) => {
            const originalPrice = !isNaN(parseInt(element['Giá nhập']))
              ? element['Giá nhập']
              : '';
            return {
              chassisNumber: element['Số Khung'],
              engineNumber: element['Số Máy'],
              serialNumber: element['Số Seri'],
              storeName: element['Kho'],
              productOld: element['Tên sản phẩm hiện tại'],
              productNew: element['Tên sản phẩm mới'],
              originalPrice: originalPrice,
              isValid: null,
              message: '',
            };
          });
          this.tmpItems = cloneDeep(this.importItems);
          this.onValidateData(this.tmpItems);
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    onChangeStatus() {
      switch (this.selectedStatus) {
        case 'all':
          this.importItems = cloneDeep(this.tmpItems);
          break;
        case 'valid':
          this.importItems = this.tmpItems.filter(
            (tmpItem) => tmpItem.isValid === true,
          );
          break;
        case 'error':
          this.importItems = this.tmpItems.filter(
            (tmpItem) => tmpItem.isValid === false,
          );
          break;
      }
    },
    getStatusName: function (item) {
      return item.isValid ? 'Hợp lệ' : 'Lỗi';
    },
  },
};
</script>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>
